import { Component, Input } from "@angular/core"
import { NotificationsService } from "angular2-notifications"
import { UserProfile } from "../../models/userProfile.model"
import { ModalService } from "../../shared-components/modal/modal.service"
import { ConfirmDeleteModalComponent } from "../../shared-components/modals/confirm-delete-modal/confirm-delete-modal.component"
import { UserProfileService } from "../../services/user-profile.service"
import { EduComponent } from "../../utils/eduComponent"
import Utils from "../../utils/utils"

@Component({
    selector: "app-user-delete-profile",
    templateUrl: "./user-delete-profile.component.html",
    styleUrl: "./user-delete-profile.component.scss",
    standalone: false,
})
export class UserDeleteProfileComponent extends EduComponent {
    @Input() sectionFragment: string
    @Input() userProfileData: UserProfile

    constructor(
        private modalService: ModalService,
        private userProfileService: UserProfileService,
        private notificationsService: NotificationsService
    ) {
        super()
    }

    public openDeleteAccountModal(): void {
        this.modalService.open(ConfirmDeleteModalComponent, {
            data: {
                title: "Delete account",
                message:
                    "This will permanently delete your PBS LearningMedia account, including all your saved lessons, favorites, folders, and class rosters." +
                    "<br><br>This action cannot be undone. Are you sure you want to continue?",
                deleteCallback: () => this.deleteAccount(),
                confirmButtonClass: "btn-red",
            },
        })
    }

    private deleteAccount(): void {
        this.addSub(
            this.userProfileService
                .deleteUserProfile(this.userProfileData.reverseToApiResponse())
                .subscribe({
                    next: () => {
                        window.location.href = "/"
                    },
                    error: () => {
                        this.notificationsService.error(
                            "Error",
                            "Something went wrong while deleting your account. Please try again.",
                            Utils.alertConfiguration
                        )
                    },
                })
        )
    }
}
